import MUIList from '@/components/MUI-Components/MUIList';
import MUIListItem from '@/components/MUI-Components/MUIList/MUIListItem';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, {Fragment, memo} from 'react';
import parse from 'html-react-parser';
import DisplayImage from '../display-image';
import {spacing, fontSize, colors} from '@/styles/tokens';

const sxWeb3ListOlItem = {display: 'list-item'};

const sxWeb3SublistWrapper = {marginLeft: spacing[16]};

// !important required: this is layered alongside the shared `.web3-list-item-header`
// classname, which sets `font-size: 18px !important` and `a { color: black !important }` —
// plain sx values can't win that fight.
const sxWeb3LargeListItem = {
    fontSize: `${fontSize[24]} !important`,
    color: `${colors.primary.main} !important`,
    '& a': {color: `${colors.primary.main} !important`}
};

const BlockchainContent = (props: any) => {
    const {blockchainTech, listType, heading, subheading} = props;
    return (
        <Box className="blockchain-parent">
            {heading && (
                <MUITypography component="h2" variant="h5" className="web3-content-header">
                    {heading}
                </MUITypography>
            )}
            {subheading && <MUITypography className="blockchain-main-header">{subheading ? parse(subheading) : ''}</MUITypography>}
            <MUIList disablePadding={true}>
                {blockchainTech?.map((item: any, index: number) => (
                    <Fragment key={index + 1}>
                        <MUIListItem
                            className={listType === 'ol' ? undefined : 'web3-list-item web3-list-spacing'}
                            sx={listType === 'ol' ? sxWeb3ListOlItem : undefined}
                            disablePadding={true}
                        >
                            {item?.header && (
                                <Typography
                                    variant="h6"
                                    component="h3"
                                    className="web3-list-item-header"
                                    sx={item?.largeHeading ? sxWeb3LargeListItem : undefined}
                                >
                                    {item?.header ? parse(item?.header) : ''}
                                </Typography>
                            )}
                        </MUIListItem>
                        {item?.body && <div>{item?.body ? parse(item.body) : ''}</div>}
                        {item?.bannerImage && (
                            <Box className="verticalMargin24">
                                <DisplayImage src={item?.bannerImage} alt={item.header} priority={false} />
                            </Box>
                        )}
                        {item?.body1 && (
                            <MUITypography className="blockchain-main-header">{item?.body1 ? parse(item?.body1) : ''}</MUITypography>
                        )}
                        {item?.body2 && (
                            <MUITypography className="blockchain-main-header">{item?.body2 ? parse(item?.body2) : ''}</MUITypography>
                        )}
                        {item?.body3 && (
                            <MUITypography className="blockchain-main-header">{item?.body3 ? parse(item?.body3) : ''}</MUITypography>
                        )}
                        {item?.content?.map((subitem: any, index: number) => (
                            <MUITypography key={index + 1} className="blockchain-main-header">
                                {subitem.subheading ? parse(subitem.subheading) : ''}
                            </MUITypography>
                        ))}
                        {item?.subList &&
                            item?.subList?.map((subItem: any, subIndex: any) => (
                                <Box key={subIndex + 1} sx={sxWeb3SublistWrapper}>
                                    <MUITypography variant="h6" className="web3-sublist-heading">
                                        {subItem?.heading ? parse(subItem?.heading) : ''}
                                    </MUITypography>
                                    <MUITypography className="blockchain-main-header">
                                        {subItem?.subheading1 ? parse(subItem?.subheading1) : ''}
                                    </MUITypography>
                                    <MUITypography className="blockchain-main-header">
                                        {subItem?.subheading2 ? parse(subItem?.subheading2) : ''}
                                    </MUITypography>
                                </Box>
                            ))}
                        {item?.detailPoints && (
                            <MUIList>
                                {item.detailPoints?.map((item: any) => (
                                    <MUIListItem key={item.heading} className="web3-list-item web3-list-spacing">
                                        <span>{item.heading ? parse(item.heading) : ''}</span>{' '}
                                        {item.content && <div style={{display: 'inline'}}>{parse(item.content)}</div>}
                                        {item.content2 && <p>{parse(item.content2)}</p>}
                                        {item.content3 && <p>{parse(item.content3)}</p>}
                                        {item?.contentData?.map((itemData: any) => (
                                            <p key={index + 1}>{parse(itemData)}</p>
                                        ))}
                                    </MUIListItem>
                                ))}
                            </MUIList>
                        )}
                        {item?.footer && (
                            <MUITypography className="blockchain-main-header" variant="h6">
                                {item?.footer ? parse(item?.footer) : ''}
                            </MUITypography>
                        )}
                    </Fragment>
                ))}
            </MUIList>
        </Box>
    );
};

export default memo(BlockchainContent);
